<app-header></app-header>

<div class="container-fluid bg-light py-4">
  <div class="container">

    <div class="card text-center border-0 shadow-lg mb-4" style="background-color: #0073CF; color: white;">
      <div class="card-body p-4">
        <h5 class="card-title text-uppercase">Seu Status Atual</h5>
        <p class="display-6 fw-bold text-uppercase" style="color: #EDC047;">Trabalhando</p>
        <p class="text-white-50">Último registro às {{ ultimoRegistro || '' }}</p>
        <button class="btn btn-light btn-lg fw-bold text-danger mt-3 px-5 py-3"
        (click)="registrarHorario()">

          <i class="bi bi-box-arrow-right me-2"></i>Registrar Horário
        </button>
      </div>
    </div>

    <div class="row g-4 mb-4">
      <div class="col-lg-3 col-md-6">
        <div class="card text-center border-0 shadow-sm h-100">
          <div class="card-body">
            <h6 class="card-title text-secondary">Horas Hoje</h6>
            <p class="card-text fs-2 fw-bold" style="color: #0073CF;">{{ resumo?.horasHoje }}</p>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6">
        <div class="card text-center border-0 shadow-sm h-100">
          <div class="card-body">
            <h6 class="card-title text-secondary">Horas na Semana</h6>
            <p class="card-text fs-2 fw-bold" style="color: #0073CF;">{{ resumo?.horasSemana }}</p>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6">
        <div class="card text-center border-0 shadow-sm h-100">
          <div class="card-body">
            <h6 class="card-title text-secondary">Horas no Mês</h6>
            <p class="card-text fs-2 fw-bold" style="color: #0073CF;">{{ resumo?.horasMes }}</p>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6">
        <div class="card text-center border-0 shadow-sm h-100">
          <div class="card-body">
            <h6 class="card-title text-secondary">Banco de Horas</h6>
            <p class="card-text fs-2 fw-bold text-success">{{ resumo?.bancoHoras }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="card border-0 shadow-sm mb-4">
      <div class="card-body d-flex justify-content-center flex-wrap gap-3">
         <button class="btn btn-secondary fw-bold"><i class="bi bi-clock-history me-2"></i>Ver meu Espelho de Ponto</button>
         <button class="btn btn-info text-white fw-bold" (click)="abrirModalFerias()"><i class="bi bi-send me-2"></i>Solicitar Férias</button>
         <button class="btn btn-warning text-dark fw-bold"><i class="bi bi-file-earmark-arrow-up me-2"></i>Enviar Atestado</button>
      </div>
    </div>

    <div class="card border-0 shadow-sm">
      <div class="card-header bg-white">
        <h5 class="mb-0">Meus Registros Recentes</h5>
      </div>
      <div class="card-body">
        <table class="table table-striped table-hover">
          <thead>
            <tr>
              <th>Data</th>
              <th>Entrada</th>
              <th>Saída Almoço</th>
              <th>Volta Almoço</th>
              <th>Saída</th>
              <th>Horas Trab.</th>
            </tr>
          </thead>
          <tbody>
  <tr *ngFor="let r of registros">
    <td>{{ formatarData(r.data) }}</td>
    <td>{{ formatarHora(r.entrada) }}</td>
    <td>{{ formatarHora(r.saidaAlmoco) }}</td>
    <td>{{ formatarHora(r.voltaAlmoco) }}</td>
    <td>{{ formatarHora(r.saida) }}</td>
    <td>
      <span class="badge"
        [ngClass]="{
          'bg-success': r.horasTrabalhadas !== '--:--' && r.horasTrabalhadas !== 'Em Andamento',
          'bg-warning text-dark': r.horasTrabalhadas === '--:--'
        }">
        {{ r.horasTrabalhadas }}
      </span>
    </td>
  </tr>
  <tr *ngIf="registros.length === 0">
    <td colspan="6" class="text-center text-muted">
      Nenhum registro encontrado
    </td>
  </tr>
</tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<app-solicitar-ferias 
  *ngIf="showSolicitacaoFeriasModal"
  (fecharModal)="fecharModalFerias()">
</app-solicitar-ferias>
